"use client";

import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["value", "defaultValue", "form", "name", "onChange", "by", "invalid", "disabled", "horizontal", "multiple", "__demoMode"],
  _excluded2 = ["id", "disabled", "autoFocus"],
  _excluded3 = ["id", "anchor", "portal", "modal", "transition"],
  _excluded4 = ["id", "disabled", "value"],
  _excluded5 = ["options", "placeholder"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useFocusRing as Ee } from "@react-aria/focus";
import { useHover as he } from "@react-aria/interactions";
import D, { Fragment as ce, createContext as fe, useCallback as K, useContext as Te, useEffect as Ae, useMemo as _e, useRef as ae, useState as Se } from "react";
import { flushSync as ie } from "react-dom";
import { useActivePress as De } from '../../hooks/use-active-press.js';
import { useByComparator as Re } from '../../hooks/use-by-comparator.js';
import { useControllable as Fe } from '../../hooks/use-controllable.js';
import { useDefaultValue as Ce } from '../../hooks/use-default-value.js';
import { useDisposables as Me } from '../../hooks/use-disposables.js';
import { useElementSize as we } from '../../hooks/use-element-size.js';
import { useEvent as B } from '../../hooks/use-event.js';
import { useHandleToggle as Be } from '../../hooks/use-handle-toggle.js';
import { useId as Y } from '../../hooks/use-id.js';
import { useInertOthers as Ie } from '../../hooks/use-inert-others.js';
import { useIsoMorphicEffect as se } from '../../hooks/use-iso-morphic-effect.js';
import { useLatestValue as ke } from '../../hooks/use-latest-value.js';
import { useOnDisappear as Ue } from '../../hooks/use-on-disappear.js';
import { useOutsideClick as Ne } from '../../hooks/use-outside-click.js';
import { useOwnerDocument as be } from '../../hooks/use-owner.js';
import { Action as Z, useQuickRelease as He } from '../../hooks/use-quick-release.js';
import { useResolveButtonType as Ge } from '../../hooks/use-resolve-button-type.js';
import { useScrollLock as Ve } from '../../hooks/use-scroll-lock.js';
import { useSlot as z } from '../../hooks/use-slot.js';
import { useSyncRefs as X } from '../../hooks/use-sync-refs.js';
import { useTextValue as Ke } from '../../hooks/use-text-value.js';
import { useTrackedPointer as ze } from '../../hooks/use-tracked-pointer.js';
import { transitionDataAttributes as We, useTransition as Xe } from '../../hooks/use-transition.js';
import { useDisabled as je } from '../../internal/disabled.js';
import { FloatingProvider as Je, useFloatingPanel as Qe, useFloatingPanelProps as $e, useFloatingReference as qe, useFloatingReferenceProps as Ye, useResolvedAnchor as Ze } from '../../internal/floating.js';
import { FormFields as et } from '../../internal/form-fields.js';
import { useFrozenData as tt } from '../../internal/frozen.js';
import { useProvidedId as ot } from '../../internal/id.js';
import { OpenClosedProvider as nt, State as ee, useOpenClosed as rt } from '../../internal/open-closed.js';
import { stackMachines as lt } from '../../machines/stack-machine.js';
import { useSlice as g } from '../../react-glue.js';
import { Focus as v } from '../../utils/calculate-active-index.js';
import { disposables as at } from '../../utils/disposables.js';
import * as it from '../../utils/dom.js';
import { Focus as me, FocusableMode as st, focusFrom as pt, isFocusableElement as ut } from '../../utils/focus-management.js';
import { attemptSubmit as dt } from '../../utils/form.js';
import { match as te } from '../../utils/match.js';
import { isActiveElement as ct } from '../../utils/owner.js';
import { RenderFeatures as ye, forwardRefWithAs as j, mergeProps as xe, useRender as J } from '../../utils/render.js';
import { useDescribedBy as ft } from '../description/description.js';
import { Keys as d } from '../keyboard.js';
import { Label as Tt, useLabelledBy as bt, useLabels as mt } from '../label/label.js';
import { Portal as yt } from '../portal/portal.js';
import { ActionTypes as xt, ActivationTrigger as pe, ListboxStates as T, ValueMode as G } from './listbox-machine.js';
import { ListboxContext as Ot, useListboxMachine as Lt, useListboxMachineContext as ue } from './listbox-machine-glue.js';
let oe = fe(null);
oe.displayName = "ListboxDataContext";
function Q(b) {
  let E = Te(oe);
  if (E === null) {
    let m = new Error("<".concat(b, " /> is missing a parent <Listbox /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(m, Q), m;
  }
  return E;
}
let Pt = ce;
function gt(b, E) {
  let m = Y(),
    u = je(),
    {
      value: s,
      defaultValue: a,
      form: _,
      name: i,
      onChange: y,
      by: o,
      invalid: x = !1,
      disabled: O = u || !1,
      horizontal: l = !1,
      multiple: t = !1,
      __demoMode: p = !1
    } = b,
    S = _objectWithoutProperties(b, _excluded);
  const h = l ? "horizontal" : "vertical";
  let I = X(E),
    R = Ce(a),
    [c = t ? [] : void 0, L] = Fe(s, y, R),
    f = Lt({
      id: m,
      __demoMode: p
    }),
    k = ae({
      static: !1,
      hold: !1
    }),
    N = ae(new Map()),
    C = Re(o),
    V = K(P => te(n.mode, {
      [G.Multi]: () => c.some(W => C(W, P)),
      [G.Single]: () => C(c, P)
    }), [c]),
    n = z({
      value: c,
      disabled: O,
      invalid: x,
      mode: t ? G.Multi : G.Single,
      orientation: h,
      onChange: L,
      compare: C,
      isSelected: V,
      optionsPropsRef: k,
      listRef: N
    });
  se(() => {
    f.state.dataRef.current = n;
  }, [n]);
  let F = g(f, P => P.listboxState),
    U = lt.get(null),
    H = g(U, K(P => U.selectors.isTop(P, m), [U, m])),
    [A, $] = g(f, P => [P.buttonElement, P.optionsElement]);
  Ne(H, [A, $], (P, W) => {
    f.send({
      type: xt.CloseListbox
    }), ut(W, st.Loose) || (P.preventDefault(), A == null || A.focus());
  });
  let r = z({
      open: F === T.Open,
      disabled: O,
      invalid: x,
      value: c
    }),
    [M, ne] = mt({
      inherit: !0
    }),
    re = {
      ref: I
    },
    q = K(() => {
      if (R !== void 0) return L == null ? void 0 : L(R);
    }, [L, R]),
    le = J();
  return D.createElement(ne, {
    value: M,
    props: {
      htmlFor: A == null ? void 0 : A.id
    },
    slot: {
      open: F === T.Open,
      disabled: O
    }
  }, D.createElement(Je, null, D.createElement(Ot.Provider, {
    value: f
  }, D.createElement(oe.Provider, {
    value: n
  }, D.createElement(nt, {
    value: te(F, {
      [T.Open]: ee.Open,
      [T.Closed]: ee.Closed
    })
  }, i != null && c != null && D.createElement(et, {
    disabled: O,
    data: {
      [i]: c
    },
    form: _,
    onReset: q
  }), le({
    ourProps: re,
    theirProps: S,
    slot: r,
    defaultTag: Pt,
    name: "Listbox"
  }))))));
}
let vt = "button";
function Et(b, E) {
  let m = Y(),
    u = ot(),
    s = Q("Listbox.Button"),
    a = ue("Listbox.Button"),
    {
      id: _ = u || "headlessui-listbox-button-".concat(m),
      disabled: i = s.disabled || !1,
      autoFocus: y = !1
    } = b,
    o = _objectWithoutProperties(b, _excluded2),
    x = X(E, qe(), a.actions.setButtonElement),
    O = Ye(),
    [l, t, p] = g(a, r => [r.listboxState, r.buttonElement, r.optionsElement]),
    S = l === T.Open;
  He(S, {
    trigger: t,
    action: K(r => {
      if (t != null && t.contains(r.target)) return Z.Ignore;
      let M = r.target.closest('[role="option"]:not([data-disabled])');
      return it.isHTMLElement(M) ? Z.Select(M) : p != null && p.contains(r.target) ? Z.Ignore : Z.Close;
    }, [t, p]),
    close: a.actions.closeListbox,
    select: a.actions.selectActiveOption
  });
  let h = B(r => {
      switch (r.key) {
        case d.Enter:
          dt(r.currentTarget);
          break;
        case d.Space:
        case d.ArrowDown:
          r.preventDefault(), a.actions.openListbox({
            focus: s.value ? v.Nothing : v.First
          });
          break;
        case d.ArrowUp:
          r.preventDefault(), a.actions.openListbox({
            focus: s.value ? v.Nothing : v.Last
          });
          break;
      }
    }),
    I = B(r => {
      switch (r.key) {
        case d.Space:
          r.preventDefault();
          break;
      }
    }),
    R = Be(r => {
      var M;
      a.state.listboxState === T.Open ? (ie(() => a.actions.closeListbox()), (M = a.state.buttonElement) == null || M.focus({
        preventScroll: !0
      })) : (r.preventDefault(), a.actions.openListbox({
        focus: v.Nothing
      }));
    }),
    c = B(r => r.preventDefault()),
    L = bt([_]),
    f = ft(),
    {
      isFocusVisible: k,
      focusProps: N
    } = Ee({
      autoFocus: y
    }),
    {
      isHovered: C,
      hoverProps: V
    } = he({
      isDisabled: i
    }),
    {
      pressed: n,
      pressProps: F
    } = De({
      disabled: i
    }),
    U = z({
      open: l === T.Open,
      active: n || l === T.Open,
      disabled: i,
      invalid: s.invalid,
      value: s.value,
      hover: C,
      focus: k,
      autofocus: y
    }),
    H = g(a, r => r.listboxState === T.Open),
    A = xe(O(), {
      ref: x,
      id: _,
      type: Ge(b, t),
      "aria-haspopup": "listbox",
      "aria-controls": p == null ? void 0 : p.id,
      "aria-expanded": H,
      "aria-labelledby": L,
      "aria-describedby": f,
      disabled: i || void 0,
      autoFocus: y,
      onKeyDown: h,
      onKeyUp: I,
      onKeyPress: c
    }, R, N, V, F);
  return J()({
    ourProps: A,
    theirProps: o,
    slot: U,
    defaultTag: vt,
    name: "Listbox.Button"
  });
}
let Oe = fe(!1),
  ht = "div",
  At = ye.RenderStrategy | ye.Static;
function _t(b, E) {
  let m = Y(),
    {
      id: u = "headlessui-listbox-options-".concat(m),
      anchor: s,
      portal: a = !1,
      modal: _ = !0,
      transition: i = !1
    } = b,
    y = _objectWithoutProperties(b, _excluded3),
    o = Ze(s),
    [x, O] = Se(null);
  o && (a = !0);
  let l = Q("Listbox.Options"),
    t = ue("Listbox.Options"),
    [p, S, h, I] = g(t, e => [e.listboxState, e.buttonElement, e.optionsElement, e.__demoMode]),
    R = be(S),
    c = be(h),
    L = rt(),
    [f, k] = Xe(i, x, L !== null ? (L & ee.Open) === ee.Open : p === T.Open);
  Ue(f, S, t.actions.closeListbox);
  let N = I ? !1 : _ && p === T.Open;
  Ve(N, c);
  let C = I ? !1 : _ && p === T.Open;
  Ie(C, {
    allowed: K(() => [S, h], [S, h])
  });
  let n = g(t, t.selectors.didButtonMove) ? !1 : f,
    F = g(t, t.selectors.hasFrozenValue) && !b.static,
    U = tt(F, l.value),
    H = K(e => l.compare(U, e), [l.compare, U]),
    A = g(t, e => {
      var de;
      if (o == null || !((de = o == null ? void 0 : o.to) != null && de.includes("selection"))) return null;
      let w = e.options.findIndex(ve => H(ve.dataRef.current.value));
      return w === -1 && (w = 0), w;
    }),
    $ = (() => {
      if (o == null) return;
      if (A === null) return _objectSpread(_objectSpread({}, o), {}, {
        inner: void 0
      });
      let e = Array.from(l.listRef.current.values());
      return _objectSpread(_objectSpread({}, o), {}, {
        inner: {
          listRef: {
            current: e
          },
          index: A
        }
      });
    })(),
    [r, M] = Qe($),
    ne = $e(),
    re = X(E, o ? r : null, t.actions.setOptionsElement, O),
    q = Me();
  Ae(() => {
    let e = h;
    e && p === T.Open && (ct(e) || e == null || e.focus({
      preventScroll: !0
    }));
  }, [p, h]);
  let le = B(e => {
      var w;
      switch (q.dispose(), e.key) {
        case d.Space:
          if (t.state.searchQuery !== "") return e.preventDefault(), e.stopPropagation(), t.actions.search(e.key);
        case d.Enter:
          e.preventDefault(), e.stopPropagation(), t.actions.selectActiveOption();
          break;
        case te(l.orientation, {
          vertical: d.ArrowDown,
          horizontal: d.ArrowRight
        }):
          return e.preventDefault(), e.stopPropagation(), t.actions.goToOption({
            focus: v.Next
          });
        case te(l.orientation, {
          vertical: d.ArrowUp,
          horizontal: d.ArrowLeft
        }):
          return e.preventDefault(), e.stopPropagation(), t.actions.goToOption({
            focus: v.Previous
          });
        case d.Home:
        case d.PageUp:
          return e.preventDefault(), e.stopPropagation(), t.actions.goToOption({
            focus: v.First
          });
        case d.End:
        case d.PageDown:
          return e.preventDefault(), e.stopPropagation(), t.actions.goToOption({
            focus: v.Last
          });
        case d.Escape:
          e.preventDefault(), e.stopPropagation(), ie(() => t.actions.closeListbox()), (w = t.state.buttonElement) == null || w.focus({
            preventScroll: !0
          });
          return;
        case d.Tab:
          e.preventDefault(), e.stopPropagation(), ie(() => t.actions.closeListbox()), pt(t.state.buttonElement, e.shiftKey ? me.Previous : me.Next);
          break;
        default:
          e.key.length === 1 && (t.actions.search(e.key), q.setTimeout(() => t.actions.clearSearch(), 350));
          break;
      }
    }),
    P = g(t, e => {
      var w;
      return (w = e.buttonElement) == null ? void 0 : w.id;
    }),
    W = z({
      open: p === T.Open
    }),
    Le = xe(o ? ne() : {}, _objectSpread({
      id: u,
      ref: re,
      "aria-activedescendant": g(t, t.selectors.activeDescendantId),
      "aria-multiselectable": l.mode === G.Multi ? !0 : void 0,
      "aria-labelledby": P,
      "aria-orientation": l.orientation,
      onKeyDown: le,
      role: "listbox",
      tabIndex: p === T.Open ? 0 : void 0,
      style: _objectSpread(_objectSpread(_objectSpread({}, y.style), M), {}, {
        "--button-width": we(f, S, !0).width
      })
    }, We(k))),
    Pe = J(),
    ge = _e(() => l.mode === G.Multi ? l : _objectSpread(_objectSpread({}, l), {}, {
      isSelected: H
    }), [l, H]);
  return D.createElement(yt, {
    enabled: a ? b.static || f : !1,
    ownerDocument: R
  }, D.createElement(oe.Provider, {
    value: ge
  }, Pe({
    ourProps: Le,
    theirProps: y,
    slot: W,
    defaultTag: ht,
    features: At,
    visible: n,
    name: "Listbox.Options"
  })));
}
let St = "div";
function Dt(b, E) {
  let m = Y(),
    {
      id: u = "headlessui-listbox-option-".concat(m),
      disabled: s = !1,
      value: a
    } = b,
    _ = _objectWithoutProperties(b, _excluded4),
    i = Te(Oe) === !0,
    y = Q("Listbox.Option"),
    o = ue("Listbox.Option"),
    x = g(o, n => o.selectors.isActive(n, u)),
    O = y.isSelected(a),
    l = ae(null),
    t = Ke(l),
    p = ke({
      disabled: s,
      value: a,
      domRef: l,
      get textValue() {
        return t();
      }
    }),
    S = X(E, l, n => {
      n ? y.listRef.current.set(u, n) : y.listRef.current.delete(u);
    }),
    h = g(o, n => o.selectors.shouldScrollIntoView(n, u));
  se(() => {
    if (h) return at().requestAnimationFrame(() => {
      var n, F;
      (F = (n = l.current) == null ? void 0 : n.scrollIntoView) == null || F.call(n, {
        block: "nearest"
      });
    });
  }, [h, l]), se(() => {
    if (!i) return o.actions.registerOption(u, p), () => o.actions.unregisterOption(u);
  }, [p, u, i]);
  let I = B(n => {
      if (s) return n.preventDefault();
      o.actions.selectOption(a);
    }),
    R = B(() => {
      if (s) return o.actions.goToOption({
        focus: v.Nothing
      });
      o.actions.goToOption({
        focus: v.Specific,
        id: u
      });
    }),
    c = ze(),
    L = B(n => c.update(n)),
    f = B(n => {
      c.wasMoved(n) && (s || x && o.state.activationTrigger === pe.Pointer || o.actions.goToOption({
        focus: v.Specific,
        id: u
      }, pe.Pointer));
    }),
    k = B(n => {
      c.wasMoved(n) && (s || x && o.state.activationTrigger === pe.Pointer && o.actions.goToOption({
        focus: v.Nothing
      }));
    }),
    N = z({
      active: x,
      focus: x,
      selected: O,
      disabled: s,
      selectedOption: O && i
    }),
    C = i ? {} : {
      id: u,
      ref: S,
      role: "option",
      tabIndex: s === !0 ? void 0 : -1,
      "aria-disabled": s === !0 ? !0 : void 0,
      "aria-selected": O,
      disabled: void 0,
      onClick: I,
      onFocus: R,
      onPointerEnter: L,
      onMouseEnter: L,
      onPointerMove: f,
      onMouseMove: f,
      onPointerLeave: k,
      onMouseLeave: k
    },
    V = J();
  return !O && i ? null : V({
    ourProps: C,
    theirProps: _,
    slot: N,
    defaultTag: St,
    name: "Listbox.Option"
  });
}
let Rt = ce;
function Ft(b, E) {
  let {
      options: m,
      placeholder: u
    } = b,
    s = _objectWithoutProperties(b, _excluded5),
    _ = {
      ref: X(E)
    },
    i = Q("ListboxSelectedOption"),
    y = z({}),
    o = i.value === void 0 || i.value === null || i.mode === G.Multi && Array.isArray(i.value) && i.value.length === 0,
    x = J();
  return D.createElement(Oe.Provider, {
    value: !0
  }, x({
    ourProps: _,
    theirProps: _objectSpread(_objectSpread({}, s), {}, {
      children: D.createElement(D.Fragment, null, u && o ? u : m)
    }),
    slot: y,
    defaultTag: Rt,
    name: "ListboxSelectedOption"
  }));
}
let Ct = j(gt),
  Mt = j(Et),
  wt = Tt,
  Bt = j(_t),
  It = j(Dt),
  kt = j(Ft),
  Mo = Object.assign(Ct, {
    Button: Mt,
    Label: wt,
    Options: Bt,
    Option: It,
    SelectedOption: kt
  });
export { Mo as Listbox, Mt as ListboxButton, wt as ListboxLabel, It as ListboxOption, Bt as ListboxOptions, kt as ListboxSelectedOption };